var _readingHistoryActionMenuSocialButtonArticle, _readingHistoryActionMenuBookmarkButtonArticle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import React, { useState } from "react";
import { graphql, readInlineData } from "react-relay";
import { useBookmarkButton } from "~/components/bookmark-button/hooks";
import { useReadingHistoryOperations } from "~/components/dashboard-widget/display/reading-history-panel/hooks";
import { findFirstNonEmptyString } from "~/lib/utils";
import { ActionDivider, ActionMenu, MenuPopper, RemoveButton, StyledBookmarkButton, StyledShareButton } from "./styles";
export const ReadingHistoryActionMenu = ({
  children
}) => {
  const {
    removeReadingHistory
  } = useReadingHistoryOperations();
  const [currentItem, setCurrentItem] = useState();
  const {
    bindBookmarkButton
  } = useBookmarkButton();
  return /*#__PURE__*/React.createElement(PopupState, {
    popupId: "reading-history-item-popover",
    variant: "popover",
    "data-qa": "reading-history-action-menu"
  }, popupState => {
    const popupTriggerProps = bindTrigger(popupState);
    const bindPopupTriggerWithItem = item => {
      const props = {
        ...popupTriggerProps
      };
      props.onClick = event => {
        setCurrentItem(item);
        popupTriggerProps.onClick(event);
      };
      return props;
    };
    const popoverProps = bindPopover(popupState);
    const closePopup = () => {
      popoverProps.onClose();
      setTimeout(() => {
        setCurrentItem(undefined);
      }, 500);
    };
    const bindPopoverWithItem = () => {
      const props = {
        ...popoverProps
      };
      props.onClose = closePopup;
      return props;
    };
    const isCurrentItem = item => popupState.isOpen && !!currentItem && currentItem.entityUuid === item.entityUuid && currentItem.createdAt === item.createdAt;
    const renderSocialButtons = item => {
      const article = readInlineData(_readingHistoryActionMenuSocialButtonArticle !== void 0 ? _readingHistoryActionMenuSocialButtonArticle : (_readingHistoryActionMenuSocialButtonArticle = require("../../../../../queries/__generated__/readingHistoryActionMenuSocialButtonArticle.graphql"), _readingHistoryActionMenuSocialButtonArticle.hash && _readingHistoryActionMenuSocialButtonArticle.hash !== "f4c88864c5a03b3f32c07b9080058e99" && console.error("The definition of 'readingHistoryActionMenuSocialButtonArticle' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _readingHistoryActionMenuSocialButtonArticle), item.article);
      const socialShareTypes = ["facebook", "twitter", "copy-link", "email"];
      return socialShareTypes.map(type => /*#__PURE__*/React.createElement(StyledShareButton, {
        extraProps: {
          copyLink: {
            tooltipPlacement: "top",
            variant: "tooltip"
          }
        },
        key: type,
        position: "history",
        relativeUrl: article.urlAlias,
        shortUrl: article.urlAlias,
        showLabel: false,
        style: {
          /* stylelint-disable csstree/validator */
          /* stylelint-disable property-no-unknown */
          backgroundColor: "transparent",
          color: "#001246",
          svgTransform: "scale(0.75)"
        },
        title: findFirstNonEmptyString(article.socialHeadline, article.headline),
        type: type,
        utm: {
          campaign: article.entityId,
          medium: "share_widget"
        },
        onClick: () => {
          closePopup();
        }
      }));
    };
    const renderBookmarkButton = item => {
      const article = readInlineData(_readingHistoryActionMenuBookmarkButtonArticle !== void 0 ? _readingHistoryActionMenuBookmarkButtonArticle : (_readingHistoryActionMenuBookmarkButtonArticle = require("../../../../../queries/__generated__/readingHistoryActionMenuBookmarkButtonArticle.graphql"), _readingHistoryActionMenuBookmarkButtonArticle.hash && _readingHistoryActionMenuBookmarkButtonArticle.hash !== "a7c80ae823596510ff3e2edc0684d236" && console.error("The definition of 'readingHistoryActionMenuBookmarkButtonArticle' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _readingHistoryActionMenuBookmarkButtonArticle), item.article);
      return /*#__PURE__*/React.createElement(StyledBookmarkButton, _extends({}, bindBookmarkButton({
        entityId: article.entityId,
        trackings: {
          events: {
            bookmark: {
              action: "My Account/Overlay/Reading History/Bookmark/Switch on",
              category: "My Account",
              label: article.urlAlias
            },
            click: {
              action: "Bookmark/Article/Click",
              category: "Bookmark",
              label: article.urlAlias
            },
            unbookmark: {
              action: "My Account/Overlay/Reading History/Bookmark/Switch off",
              category: "My Account",
              label: article.urlAlias
            }
          },
          ga4Events: {
            click: {
              action: "click",
              category: "bookmark",
              customized_parameters: {
                action_type: "add",
                article_id: article.entityId,
                trigger_point: "history"
              },
              subcategory: ""
            }
          }
        }
      }, () => {
        setTimeout(closePopup, 500);
      }), {
        "data-qa": "render-bookmark-button"
      }));
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, children({
      bindTrigger: bindPopupTriggerWithItem,
      isCurrentItem
    }), /*#__PURE__*/React.createElement(MenuPopper, _extends({
      anchorOrigin: {
        horizontal: "left",
        vertical: "top"
      },
      elevation: 4,
      transformOrigin: {
        horizontal: "left",
        vertical: "bottom"
      }
    }, bindPopoverWithItem()), currentItem ? /*#__PURE__*/React.createElement(ActionMenu, null, renderBookmarkButton(currentItem), /*#__PURE__*/React.createElement(ActionDivider, null), renderSocialButtons(currentItem), /*#__PURE__*/React.createElement(ActionDivider, null), /*#__PURE__*/React.createElement(RemoveButton, {
      onClick: () => {
        closePopup();
        void removeReadingHistory(currentItem.article, currentItem.createdAt);
      }
    }, "Remove")) : null));
  });
};
ReadingHistoryActionMenu.displayName = "ReadingHistoryActionMenu";